import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { LoginService } from './login.service';
import { Token } from '../types/token';
import { environment } from '../../../environments/environment';
import { ApartmentComplex } from '../types/apartment-complex';
import { NotificationContact } from '../types/notitication-contact-info';

@Injectable()
export class ApartmentComplexService {

  constructor(
    private http: HttpClient
  ) { }

  getApartmentComplex(): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/complexes`, {headers: headers});
  }

  getApartmentComplexByID(id: number) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get<ApartmentComplex>(`${environment.api}api/complexes/${id}`, {headers: headers});
  }

  getDefaultsID(id: number) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get<ApartmentComplex>(`${environment.api}api/complexes/defaults/${id}`, {headers: headers});
  }

  getAptComplexBillingAddress(id: number) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/complexes/${id}/billingaddress`, {headers: headers});
  }

  getCustomItems(id: number) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/apartments/${id}/customitems`, {headers: headers});
  }

  validApartment(apartmentNumber, apartmentComplexID, apartmentId): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http
      .get(`${environment.api}api/apartments/validateapartment`, {
        headers, params: {apartmentId, apartmentNumber, apartmentComplexID}
      });
  }

  validateRequierePONumber(): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/apartments/isporequired`, {headers: headers});
  }

  getTrackingDetail(orderNumber): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http
      .get(`${environment.api}api/apartments/gettrackingdetail`, {
        headers, params: {orderNumber}
      });
  }

  getAvailableCredit(): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/account/creditlimit`, {headers: headers});
  }

  getAmountBalanceLimitAlert(): Observable<number> {
    return this.http.get<number>(`${environment.api}api/account/amountBalanceLimitAlert`);
  }

  getLedgeEntries(): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/account/leadgeEntries`, {headers: headers});
  }

  getAllInvoices(): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/account/invoices`, {headers: headers});
  }

  getAllInvoicesPaged(page, pageSize, searchText: string): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/account/invoicesPaged`, {headers: headers, params:{page, pageSize, searchText}});
  }

  getDueLedgeEntries(): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/orders/dueleadgeEntries`, {headers: headers});
  }

  getShoppingCartGroup(apartmentId): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/orders/getShoppingCartGroup`, {headers, params: {apartmentId}});
  }

  createNotificationContact(body: NotificationContact, apartmentComplexId): Observable<any>{
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(`${environment.api}api/complexes/addnotification`, body, {headers:headers, params: {apartmentComplexId}});
  }

  modifyNotificationContact(body: NotificationContact): Observable<any>{
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.put(`${environment.api}api/complexes/editnotification`, body, {headers:headers});
  }

  deleteNotificationContact(notificationId: any): Observable<any>{
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.delete(`${environment.api}api/complexes/deletenotification`, {headers: headers, params:{notificationId}})
  }

  getNotificationContact(complexId: number): Observable<Array<NotificationContact>>{
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get<Array<NotificationContact>>(`${environment.api}api/complexes/getnotification/${complexId}`, {headers: headers})
  }

  hasUserResponded(complexId: number): Observable<boolean>{
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get<boolean>(`${environment.api}api/complexes/has-user-responded/${complexId}`, {headers: headers})
  }

  registerUserResponse(apartmentComplexId): Observable<any>{
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(`${environment.api}api/complexes/register-response`, {}, {headers:headers, params: {apartmentComplexId}});
  }

  getLocationByCode(code: string): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.apiQwikkitOrdering}api/ApartmentComplex/GetApartmentComplexByCode`, {headers: headers, params: {code: code}});
  }

  getComplexSpecialNotes(complexId: number): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');    
    return this.http.get(`${environment.api}api/complexes/getSpecialNotes?complexId=${complexId}`, {headers: headers});
  }

 saveComplexNotes(specialNotes: string, complexId: number): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  const encodedNotes = encodeURIComponent(specialNotes);

  return this.http.put(
    `${environment.api}api/complexes/updateSpecialNotes?complexId=${complexId}&specialNotes=${encodedNotes}`,
    {},
    { headers: headers }
  );
}
}